



































import { Component, Vue } from 'vue-property-decorator';
import { authUser, User } from '@/auth/User';

@Component
export default class LoginBox extends Vue
{
    email: string = '';
    password: string = '';
    error: string | null = null;
    return_url: string = '/';
    loading: boolean = false;

    async login()
    {
        if( 'return_url' in this.$route.query )
            this.return_url = this.$route.query[ 'return_url' ] as string || '/';

        try
        {
            this.loading = true;
            await authUser.login( this.email, this.password );
            const emgyneRoute = this.return_url.includes( 'emgyne' );
            const emmaRoute = this.return_url.includes( 'emma' );
            if( emgyneRoute )
                this.$router.push( '/emgyne' );
            else if( emmaRoute )
                this.$router.push( '/emma' );
            else
                this.$router.push( '/' );

        }
        catch( error )
        {
            localStorage.removeItem( 'auth_token' );
            localStorage.removeItem( 'refresh_token' );
            this.error = 'Utente non riconosciuto';
        }
        this.loading = false;
    }
}
